(() => {
  const getSectionId = (root) => {
    const productInfo = root.closest('product-info');
    return productInfo?.dataset?.section;
  };

  const getCurrentFormVariantId = (sectionId) => {
    const form = document.getElementById(`product-form-${sectionId}`);
    const input = form?.querySelector('input[name="id"]');
    return input?.value || null;
  };

  const swapMainProductSection = async ({ sectionId, productUrl, variantId }) => {
    const currentSection = document.getElementById(`MainProduct-${sectionId}`);
    if (!currentSection) throw new Error('Could not find current MainProduct section');

    const res = await fetch(`${productUrl}?variant=${variantId}&section_id=${sectionId}`, {
      credentials: 'same-origin'
    });
    if (!res.ok) throw new Error(`Failed to fetch section HTML for ${productUrl}`);

    const htmlText = await res.text();
    const html = new DOMParser().parseFromString(htmlText, 'text/html');
    const updatedSection = html.getElementById(`MainProduct-${sectionId}`);
    if (!updatedSection) throw new Error('Fetched HTML did not include expected MainProduct section');

    currentSection.replaceWith(updatedSection);

    document.dispatchEvent(
      new CustomEvent('main-product-section:replaced', {
        bubbles: true,
        detail: { sectionId }
      })
    );

    const nextUrl = `${productUrl}?variant=${variantId}`;
    window.history.pushState({ variantId, productUrl }, '', nextUrl);
  };

  let queued = null;
  const queueSwap = (staticPicker) => {
    const sectionId = getSectionId(staticPicker);
    if (!sectionId) return;

    const productUrl = staticPicker.dataset.url;
    if (!productUrl) return;

    // Wait for the theme's variant component to finish updating the hidden variant input.
    if (queued) window.clearTimeout(queued);
    queued = window.setTimeout(async () => {
      const variantId = getCurrentFormVariantId(sectionId) || staticPicker.currentVariant?.id;
      if (!variantId) return;

      try {
        staticPicker.classList.add('is-loading');
        await swapMainProductSection({ sectionId, productUrl, variantId });
      } catch (e) {
        console.error(e);
      } finally {
        staticPicker.classList.remove('is-loading');
      }
    }, 0);
  };

  document.addEventListener('change', (event) => {
    const staticPicker = event.target.closest('[data-variant-picker-context="static"]');
    if (!staticPicker) return;
    queueSwap(staticPicker);
  });

  document.addEventListener('click', (event) => {
    // Clicking a swatch label may not always yield a reliable change event order,
    // so we queue a swap on click as well.
    const staticPicker = event.target.closest('[data-variant-picker-context="static"]');
    if (!staticPicker) return;
    if (!event.target.closest('label, input, option, select')) return;
    queueSwap(staticPicker);
  });
})();

